module.exports = __webpack_public_path__ + "media/images/donation/donation_share_panel_deco-a8995533bbd409427b41132b968b2418.svg";